export const CLEARANCE_WEEKLY_SCHEMA = [
  {
    name: 'dms',
    ua_name: 'DMS',
    eng_name: 'Clearance weekly',
    children: [
      { name: 'report_date', ua_name: 'Дата звіту', eng_name: 'Report date' },
      { name: 'reporter_organization', ua_name: 'Організація', eng_name: 'Organization' },
      { name: 'donor', ua_name: 'Донор', eng_name: 'Donor' },
      { name: 'task_customer', ua_name: 'Замовник задачі', eng_name: 'Task customer' },
      { name: 'team_id', ua_name: 'ID команди', eng_name: 'Team ID' },
      { name: 'user', ua_name: 'Хто створив звіт', eng_name: 'Report creator' },
      { name: 'reporter_position', ua_name: 'Його посада', eng_name: 'Reporter position' },
      { name: 'maintenance_day_exists', ua_name: 'Діяльність команди', eng_name: 'Team activity' },
      { name: 'maintenance_day', ua_name: 'DMS Коментарі', eng_name: 'Maintance day training comments' },
    ],
  },
  {
    name: 'field_work',
    ua_name: 'Робота у полі',
    eng_name: 'Field work',
    children: [
      { name: 'clearance_task_imsma_id', ua_name: 'ID завдання', eng_name: 'Task ID' },
      { name: 'task_type', ua_name: 'Тип завдання', eng_name: 'Task type' },
      { name: 'field_work_cleared_area', ua_name: 'Очищена область', eng_name: 'Area cleared' },
      { name: 'eo_found', ua_name: 'Знайдено ВНП', eng_name: 'EO found' },
      { name: 'deminer_progress_polygon', ua_name: 'Карта', eng_name: 'Deminer progress polygon' },
      { name: 'daily_progress_polygon', ua_name: 'Карта', eng_name: 'Daily progress polygon' },
      { name: 'remarks', ua_name: 'Коментарі', eng_name: 'Field work comments' },
      { name: 'number_of_deminers_on_the_field', ua_name: 'Кількість саперів на полі', eng_name: 'Number of deminers in the field' },
      { name: 'region', ua_name: 'Область', eng_name: 'Region' },
      { name: 'district', ua_name: 'Район', eng_name: 'District' },
      { name: 'local_community', ua_name: 'Територіальна громада', eng_name: 'Local community' },
      { name: 'settlement_name', ua_name: 'Населений пункт', eng_name: 'Locality' },
    ],
  },
  {
    name: 'marking',
    ua_name: 'Маркування',
    eng_name: 'Marking',
    children: [
      { name: 'area', ua_name: 'Маркована область', eng_name: 'Area Marked' },
      { name: 'points', ua_name: 'Точки на карті', eng_name: 'Marking points' },
      { name: 'marking_files', ua_name: 'Файли', eng_name: 'Marking files' },
      { name: 'marking_remarks', ua_name: 'Коментарі', eng_name: 'Marking comments' },
    ],
  },
  {
    name: 'eo_found_tab',
    ua_name: 'Знайдено ВНП',
    eng_name: 'EO found',
    children: [
      { name: 'mines', ua_name: 'Міни', eng_name: 'EO found mines' },
      { name: 'uxos', ua_name: 'Uxo&axo', eng_name: 'EO found uxo&axo' },
      { name: 'ied', ua_name: 'IED', eng_name: 'EO found IED' },
      { name: 'saa', ua_name: 'SAA', eng_name: 'EO found SAA' },
      { name: 'date', ua_name: 'Дата', eng_name: 'Hand over date' },
      { name: 'name', ua_name: 'Людина, яка прийняла ВНП', eng_name: 'EO found name of a person accepted EO' },
      { name: 'hand_over_files', ua_name: 'Файли hand over', eng_name: 'Hand over files' },
      { name: 'hand_over_remarks', ua_name: 'Коментарі hand over', eng_name: 'Hand over comments' },
    ],
  },
  {
    name: 'cl_daily_id',
    ua_name: 'ID звіту',
    eng_name: 'Report ID in database',
    children: [
      { name: 'id', ua_name: 'ID звіту', eng_name: 'Report ID in database' },
    ],
  },
  {
    name: 'created_at',
    ua_name: 'Дата створення',
    eng_name: 'Created at',
    children: [
      { name: 'created_at', ua_name: 'Дата створення', eng_name: 'Created at' },
    ],
  },
  {
    name: 'comments_summary',
    ua_name: 'Коментарі звіту',
    eng_name: 'Comments summary',
    children: [
      { name: 'comments_summary', ua_name: 'Коментарі звіту', eng_name: 'Comments summary' },
      { name: 'status_manually_changed', ua_name: 'Статус', eng_name: 'Manual status' },
      { name: 'display_validation_status', ua_name: 'Статус', eng_name: 'Validation status' },
      { name: 'imsma_comments_summary', ua_name: 'IMSMA коментарі', eng_name: 'IMSMA comments summary' },
    ],
  },
];


